KROWN.themeName = 'Split';
KROWN.themeVersion = '4.2.1';

// Caching DOM elements to minimize lookups
const overlay = document.querySelector('.site-overlay');
const sidebarCloseButton = document.querySelector('.site-close-handle');
const plusIcons = document.querySelectorAll('.plus-icon');

const isB2BCustomer = document
      .querySelector('meta[name="isB2BCustomer"]')
      .getAttribute('content') === 'true';

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getRecentlyViewedProducts() {
    var cookie = getCookie('recently_viewed_products');
    return cookie ? JSON.parse(cookie) : [];
}

function addRecentlyViewedProduct(productId) {
    var viewedProducts = getRecentlyViewedProducts();
    
    // Remove current product if it exists already
    var index = viewedProducts.indexOf(productId);
    if (index > -1) {
        viewedProducts.splice(index, 1);
    }
    
    // Add current product to the beginning
    viewedProducts.unshift(productId);
    
    // Limit to 10 most recent products
    viewedProducts = viewedProducts.slice(0, 10);
    
    // Save back to cookie
    setCookie('recently_viewed_products', JSON.stringify(viewedProducts), 30);
}

function toggleOverlayMobile() {
    var size_swatch = this.parentElement.parentElement;

  var size_infoParent = size_swatch.parentElement.nextElementSibling;
    var size_info = size_infoParent.classList.contains('mlv_var_class') ?
        size_infoParent.childNodes[1] :
        size_infoParent.nextElementSibling.childNodes[1];
  
    if(overlay) {
      overlay.classList.add('active');
      document.querySelector('html').classList.add('kill-overflow');

      var mobileQuickBuy = document.querySelector('.mobile-quick-buy');
      mobileQuickBuy.innerHTML = size_info.innerHTML;
      mobileQuickBuy.classList.add('open');
    
      overlay.addEventListener('click', function() {
          overlay.classList.remove('active');
          document.querySelector('html').classList.remove('kill-overflow');
          mobileQuickBuy.classList.remove('open');
      });

      $('.mlv__list-item--label').click(handleClickQuickAdd);
      $('.mlv__list-item--label').on('click', e => handleClickQuickAdd(e));
    }
}

if (typeof variantIds_product !== 'undefined') {
    variantIds_product = [];
} else {
    let variantIds_product = [];
}
function extractVariantId(fullVariantId) {
  // Check if the variantId contains a slash ('/')
  // if (fullVariantId.includes('/')) {
  //   // Split the string by '/' and return the last part
  //   return parseInt(fullVariantId.split('/').pop(), 10);
  // }
  // // If already formatted, return the original variantId
  // return parseInt(fullVariantId, 10);;
}

variantIds_product = [];

function CheckProductQuantity() {
    variantIds_product = [];


    // Check if we're on a product or collection page
    if (!document.body.classList.contains('template-product')) {
        // Other page logic (homepage, collection...)
        $(".limit_variant").each(function () {
            variantIds_product.push($(this).data("id"));
        });

        if (variantIds_product.length > 0) {
            variantIds_product.forEach(variantId => {
                updateVariantAvailability(variantId);
            });
        }
    } else {
        // Product page logic
        $(".limit_variant").each(function () {
            variantIds_product.push($(this).data("id"));
        });

        if (variantIds_product.length > 0) {
            variantIds_product.forEach(variantId => {
                updateVariantAvailability(variantId);
            });
        }
    }
}

if(!CACHE_DURATION) {
  var CACHE_DURATION = 120000; // 2 minutes in milliseconds
}

if(!lastCartUpdateTimestamp) {
  var lastCartUpdateTimestamp = 0;
}

if(!cachedCartData) {
  var cachedCartData = null;
}

async function getCartData() {
  const now = Date.now();
  if (cachedCartData && (now - lastCartUpdateTimestamp < CACHE_DURATION)) {
    return cachedCartData;
  }
  
  try {
    const response = await fetch("/cart.js");
    cachedCartData = await response.json();
    lastCartUpdateTimestamp = now;
    return cachedCartData;
  } catch (error) {
    console.error("Error fetching cart data:", error);
    throw error;
  }
}

function updateVariantAvailability(variantId) {
  const variantElement = document.querySelector(`.limit_variant[data-id="${variantId}"]`);

  if (variantElement) {
    const orderLimit = Number(variantElement.getAttribute("data-meta"));
    let limitInventory = Number(variantElement.getAttribute("data-inventory"));

    // Regardless of pre-order or regular, we check the cart and total available inventory
    limitInventory += orderLimit; // Add order limit if applicable (will be 0 for in-stock-only products)

    // Fetch the current cart to compare quantities
    getCartData()
      .then(data => {
        let cartQuantity = 0;

        // Loop through cart items and check the quantity for this variant
        data.items.forEach(item => {
          if (variantId == item.id) {
            cartQuantity = item.quantity;
          }
        });

        // Update the UI based on the comparison between inventory and cart quantity
        updateVariantUI(variantId, limitInventory, cartQuantity);
      })
      .catch(error => {
        console.error("Error fetching cart data: ", error);
      });
  }
}

// Function to check variant availability
// function updateVariantAvailability(variantId) {
//     const variantElement = document.querySelector('.limit_variant[data-id="' + variantId + '"]');
  
//     if (variantElement) {
//         const orderLimit = Number(variantElement.getAttribute("data-meta"));
//         let limitInventory = Number(variantElement.getAttribute("data-inventory"));
        
//         // Regardless of pre-order or regular, we check the cart and total available inventory
//         limitInventory += orderLimit; // Add order limit if applicable (will be 0 for in-stock-only products)

//         // Fetch the current cart to compare quantities
//         $.ajax({
//             type: "GET",
//             url: "/cart.js",
//             dataType: "JSON",
//             success: function (data) {
//                 let cartQuantity = 0;

//                 // Loop through cart items and check the quantity for this variant
//                 data.items.forEach(item => {
                    
//                     if (variantId == item.id) {
//                         cartQuantity = item.quantity;
//                     }
//                 });

//                 // Update the UI based on the comparison between inventory and cart quantity
//                 updateVariantUI(variantId, limitInventory, cartQuantity);
//             },
//             error: function (error) {
//                 console.error("Error fetching cart data: ", error);
//             }
//         });
//     }
// }

function updateVariantUI(variantId, limitInventory, cartQuantity) {
    if (cartQuantity >= limitInventory) {
        setVariantUnavailable(variantId);
    } else {
        setVariantAvailable(variantId);
    }
}

// Disable the variant in the UI
function setVariantUnavailable(variantId) {
    const variantElement = document.querySelector('.mlv__list-item[data-id="' + variantId + '"]');
    if (variantElement) {
        variantElement.classList.remove("available");
        variantElement.classList.add("unavailable");

        const inputElement = variantElement.querySelector("input");
        if (inputElement) {
            inputElement.disabled = true;
        }

        // Add strikethrough for visual feedback
        variantElement.style.textDecoration = "line-through";
    }
}

// Enable the variant in the UI
function setVariantAvailable(variantId) {
    const variantElement = document.querySelector('.mlv__list-item[data-id="' + variantId + '"]');
    if (variantElement) {
        variantElement.classList.remove("unavailable");
        variantElement.classList.add("available");

        const inputElement = variantElement.querySelector("input");
        if (inputElement) {
            inputElement.disabled = false;
        }

        // Remove strikethrough for visual feedback
        variantElement.style.textDecoration = "none";
    }
}

$(document).ready(function () {
    CheckProductQuantity();
});

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

// function addItemToCart(variant_id, qty, title, shippingDate) {
//     if (!variant_id) return;

//     let formData = {
//         'items': [{
//             'id': variant_id,
//             'quantity': qty,
//             'properties': {
//                 '_shipped_by': shippingDate
//             }
//         }]
//     };

//     fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json'
//         },
//         body: JSON.stringify(formData)
//     })
//     .then(response => response.json())
//     .then(response => {
//         if (response.status === 422) {
//             const alert = document.createElement('span');
//             alert.classList.add('alert', 'alert--error');
//             alert.isHtmlError = true;
//             alert.innerHTML = response.description || response.message;
//             throw alert;
//         }
//         //close the quickadd window if necessary
//         document.querySelector('.mobile-quick-buy')?.classList.remove('open');
//         window.refreshCart();
//         CheckProductQuantity(); // Refresh the availability of variants
//     })
//     .catch(error => {
//         console.error("Error adding to cart:", error);
//     });
// }

async function addItemToCart(variant_id, qty, title, shippingDate) {  
    if (!variant_id) return;
  
    try {
        // Check if the product is a pre-order item
        const variantElement = document.querySelector(`.limit_variant[data-id="${variant_id}"]`);
        const isPreOrder = variantElement && Number(variantElement.getAttribute("data-meta")) > 0;
      
        if (isPreOrder) {
            // Perform server-side check only for pre-order items
            const checkResponse = await fetch('https://ca96haabp7.execute-api.eu-west-3.amazonaws.com/prod/validate-preorder', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ variantId: variant_id, quantity: qty }),
            });

            const checkResult = await checkResponse.json();

            // If the server-side check fails, don't proceed with adding to cart
            if (!checkResult.success) {
                return; // Exit the function without adding to cart
            }
        }

        // Proceed with adding to cart (for both pre-order and regular items)
        let formData = {
            'items': [{
                'id': variant_id,
                'quantity': qty,
                'properties': {
                    '_shipped_by': shippingDate
                }
            }]
        };

        const addResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        });

        const addResult = await addResponse.json();

        if (addResponse.status === 422) {
            const alert = document.createElement('span');
            alert.classList.add('alert', 'alert--error');
            alert.isHtmlError = true;
            alert.innerHTML = addResult.description || addResult.message;
            throw alert;
        }

        //update the cart data now for product pages
        document.dispatchEvent(new CustomEvent('cart:updatecache'));

        // Close the quickadd window if necessary
        document.querySelector('.mobile-quick-buy')?.classList.remove('open');
        window.refreshCart();
        CheckProductQuantity(); // Refresh the availability of variants

    } catch (error) {
        console.error("Error adding to cart:", error);
        // You can handle errors here if needed, but won't show any to the user
    }
}

async function handleClickQuickAdd(e) {
    e.stopPropagation();
    e.stopImmediatePropagation();
    e.preventDefault();

    var ID = jQuery(this).parent('li').find('a').attr("data-vari");
    var TITLE = jQuery(this).parent('li').find('a').attr("data-title");
    var SHIPPING = jQuery(this).parent('li').find('a').attr("data-shipping");
    var _This = jQuery(this);

    await addItemToCart(ID, 1, TITLE, SHIPPING);
}

// Function to reinitialize Trustpilot widget
function reinitializeTrustpilot() {
  // Check if Trustpilot object is available
  if (window.Trustpilot) {
    // Select the Trustpilot widget container
    var trustpilotWidget = document.querySelector('.trustpilot-widget');
    if (trustpilotWidget) {
      // Reinitialize the widget
      window.Trustpilot.loadFromElement(trustpilotWidget, true);
    }
  }
}

const executeOnceOnDomContentLoaded = ()=>{

  // tab navigation

  let activeElement = document.activeElement;
  document.addEventListener('keyup', e=>{
    if ( e.keyCode == window.KEYCODES.TAB ) {
      if ( activeElement.classList.contains('focus') && e.target != activeElement ) {
        activeElement.classList.remove('focus');
      }
      if ( e.target.classList.contains('product-variant__input') ||
      	e.target.classList.contains('button') ||
      	e.target.classList.contains('product-item') ||
      	e.target.classList.contains('spr-summary-actions-newreview') ||
      	e.target.classList.contains('site-box-content-to-focus')
      ) {
        e.target.classList.add('focus');
      } 
      activeElement = document.activeElement;
    }
  });

  // newsletter has jump

  if ( window.location.pathname.includes('/challenge') ) {
    setTimeout(()=>{
      window.scroll({
        top: 0, 
        behavior: 'auto'
      });
    }, 300);
  }

  // fix image link borders

  document.querySelectorAll('.rte a img').forEach(elm=>{
    elm.parentNode.style.border = 'none';
  });

  // Filter handle
  
  if ( document.getElementById('site-filter-handle') ) {
    const filterHolderMobile = document.querySelector('.site-filter-handle-holder-mobile');
    if(filterHolderMobile) {
      filterHolderMobile.addEventListener('click', e=>{
        document.getElementById('site-filters').show();
        document.getElementById('site-filter-handle').setAttribute('aria-expanded', 'true');
      }, {passive: true});
    }
    document.getElementById('site-filter-handle').addEventListener('click', e=>{
      document.getElementById('site-filters').show();
      document.getElementById('site-filter-handle').setAttribute('aria-expanded', 'true');
    }, {passive: true});
  }

  // fix quick add to cart

  setTimeout(()=>{
    if ( document.querySelector('modal-box quick-view-product') ) {
      document.querySelector('modal-box quick-view-product').init();
    }
    if ( document.querySelector('modal-box quick-add-to-cart') ) {
      document.querySelector('modal-box quick-add-to-cart').init();
      document.querySelector('modal-box product-form').init();
    }
  }, 3050);

  // show newsletter popup confimation

  if ( document.location.search == '?customer_posted=true' && document.location.hash == '#newsletter-popup' && document.getElementById('modal-newsletter') ) {
    const newsletterPopup = document.getElementById('modal-newsletter');
    newsletterPopup.show();
    localStorage.setItem(newsletterPopup._modalKey, JSON.stringify({
      'shown': (new Date().getTime()),
      'content': newsletterPopup._modalText
    }));	
    setTimeout(()=>{
      newsletterPopup.querySelectorAll('[data-js-close]').forEach(elm=>elm.addEventListener('click',()=>{newsletterPopup.hide(true)}));
    }, 100);
    clearTimeout(newsletterPopup._modalTimeout);
  }

  // custom cart listener
  
  if ( document.querySelector('cart-form') ) {
    document.querySelector('cart-form').addEventListener('cart-updated', ()=>{
      if ( document.body.classList.contains('template-cart') ) {

        if ( document.querySelector('#AjaxCartForm .subtitle') ) {
          document.querySelector('#section-cart .box__heading .subtitle').innerHTML = document.querySelector('#AjaxCartForm .subtitle').innerHTML;
        }
        if ( document.getElementById('AjaxCartSubtotal').querySelector('[data-cart-empty]') ) {
          document.querySelector('#section-cart .box__heading .subtitle').innerHTML = "";
          if ( ! document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content') ) {
            document.getElementById('AjaxCartSubtotal').append(document.getElementById('section-cart').querySelector('template').content.cloneNode(true))
          } else {
            document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content').style.display = 'block';
          }
        } else if ( document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content') ) {
          document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content').style.display = 'none';
        }

      }

      if ( document.querySelector('cart-recommendations') && parseInt(document.querySelector('[data-cart-count]').textContent ) == 0 ) {
        document.querySelector('cart-recommendations').innerHTML = '';
      }

    }, {passive: true});
  }

  // recommended products listener

  if ( document.querySelector('#main-product-recommendations') ) {
    document.querySelector('#main-product-recommendations').addEventListener('product-recommendations-loaded', ()=>{
      eval(document.querySelector('#main-product-recommendations .js-fix-height').textContent);
      if ("ontouchstart" in document.documentElement) {
      } else {
        $('#main-product-recommendations .mlv_image').hover(function () {
          this.parentElement.querySelector('div.mlv_dis_class').classList.add('mlv_hide'),
          this.parentElement.querySelector('.mlv_var_class').classList?.remove('mlv_hide')
        }, function () {
          this.parentElement.querySelector('div.mlv_dis_class').classList.remove('mlv_hide'),
          this.parentElement.querySelector('.mlv_var_class').classList?.add('mlv_hide')
        });
      }

      var plus = document.querySelectorAll(".plus-icon");
      plus.forEach(link => {
        if(!link.classList.contains('one-size')){
          link.addEventListener('click', toggleOverlayMobile, {passive: true});
        }
      });
      
      $('.mlv__list-item--label').click(handleClickQuickAdd);
      $('.mlv__list-item--label').on('click', e => handleClickQuickAdd(e));

      CheckProductQuantity();
    }, {passive: true});
  }


  // Function to reset quick-order-list quantities
  function resetQuickOrderListQuantities() {
    //check whether product not sold out (no need to refresh the quantities)
    // Check if product is sold out using meta-productSoldOut attribute
    const quickOrderListContainer = document.querySelector('.quick-order-list-container');
    const isSoldOut = quickOrderListContainer?.getAttribute('meta-productSoldOut') === 'true';

    // If the product is sold out, return early and disable functionality
    if (isSoldOut) {
      return;
    }
    
    const quickOrderList = document.querySelector('quick-order-list');
    if (quickOrderList) {
      quickOrderList.refresh().then(() => {
        quickOrderList.resetQuantitiesToMatchCart();
      });
    }
  }

  //check quantities again when cart sidebar is closed
  // if(overlay) {
  //   overlay.addEventListener('click', function() {
  //     if(isB2BCustomer) {
  //       resetQuickOrderListQuantities();
  //     } else {
  //       CheckProductQuantity();
  //     }
  //   });
  // }

  const debouncedCheckProductQuantity = debounce(function() {
    if(isB2BCustomer) {
      resetQuickOrderListQuantities();
    } else {
      CheckProductQuantity();
    }
  }, 250); // 250ms delay, adjust as needed
  
  //check quantities again when cart sidebar is closed
  if(overlay) {
    overlay.addEventListener('click', function() {
      debouncedCheckProductQuantity();
    });
  }

  if(sidebarCloseButton) {
    sidebarCloseButton.addEventListener('click', function() {
      debouncedCheckProductQuantity();
    });
  }

  //adding event listeners for the quick add options on desktop
  $('.mlv__list-item--label').click(handleClickQuickAdd);
  $('.mlv__list-item--label').on('click', e => handleClickQuickAdd(e));

  //adding functionality to the quick add plus icon
  if(plusIcons) {
    plusIcons.forEach(link => {
      if(!link.classList.contains('one-size')){
        link.addEventListener('click', toggleOverlayMobile, {passive: true});
      }
    });
  } else {
    var plusIcons = document.querySelectorAll(".plus-icon");
    plusIcons.forEach(link => {
      if(!link.classList.contains('one-size')){
        link.addEventListener('click', toggleOverlayMobile, {passive: true});
      }
    });
  }
  
  setTimeout(function(){
    var plus = document.querySelectorAll("#recomended--recommendation-section .plus-icon");
    plus.forEach(link => {
      if(!link.classList.contains('one-size')){
        link.addEventListener('click', toggleOverlayMobile, {passive: true});
      }
    });
  },1000);
}

if ( document.readyState !== 'loading' ) {
  executeOnceOnDomContentLoaded();
} else {
  document.addEventListener('DOMContentLoaded', executeOnceOnDomContentLoaded);
}

if ( typeof SiteFilterHandle !== 'function' ) {

	class SiteFilterHandle extends HTMLElement {
		constructor(){
			super();
			const sidebar = document.getElementById(this.getAttribute('aria-controls'));
			this.addEventListener('click', e=>{
				if ( ! this.classList.contains('disable-sidebar') ) {
					e.preventDefault();
					this.setAttribute('aria-expanded', 'true');
					sidebar.show();
				}
			})
			this.addEventListener('keyup', e=>{
				if ( e.keyCode == window.KEYCODES.RETURN ) {
					this.setAttribute('aria-expanded', 'true');
					sidebar.show();
					sidebar.querySelector('.site-close-handle').focus();
				}
			}, {passive: true})
		}
  }

  if ( typeof customElements.get('site-filter-handle') == 'undefined' ) {
    customElements.define('site-filter-handle', SiteFilterHandle);
  }
}


// B2B start
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    // this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      // this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);
// B2B end

document.addEventListener('DOMContentLoaded', function() {
  var favoriteProductIds = JSON.parse(localStorage.getItem('suspicious-favorites'));

  // Get the menu item element with the specific link to 'pages/saved-items'
  const savedItemsLinks = document.querySelectorAll('a.menu-link[href="/pages/saved-items"]');

  savedItemsLinks.forEach(function(link) {
    if (favoriteProductIds && favoriteProductIds.length > 0) {
      // Show the element if the cookie is present
      link.style.display = 'block';
      if (link.closest('li.has-submenu')) {
        link.closest('li.has-submenu').style.display = 'block';
        link.closest('li.has-submenu').style.opacity = '1';
      }
    } else {
      // Hide the element and its parent if necessary
      link.style.display = 'none';
      if (link.closest('li.has-submenu')) {
        link.closest('li.has-submenu').style.display = 'block';
        link.closest('li.has-submenu').style.opacity = '0';
      }
    }
  });
});